import { render, staticRenderFns } from "./PhilosophySection.vue?vue&type=template&id=e00f4af6&scoped=true"
import script from "./PhilosophySection.vue?vue&type=script&lang=js"
export * from "./PhilosophySection.vue?vue&type=script&lang=js"
import style0 from "./PhilosophySection.vue?vue&type=style&index=0&id=e00f4af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00f4af6",
  null
  
)

export default component.exports